// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowDown_arrow__kgTzA","arrowActive":"ArrowDown_arrowActive__tJO_u"};